<section *transloco="let t; read: TRANSLATION_SCOPE">
  <h2 data-qa="test-company-payment-title">{{ t('title') }}</h2>
  <p class="py-2" data-qa="test-company-payment-subtitle">{{ t('subtitle', { company: companyName$ | async }) }}</p>
  <rx-alert *ngIf="companySettingsFacade.companyPageError$ | async" type="danger" [message]="t('defaultError')" />

  <rx-alert
    *ngIf="companySettingsFacade.confirmSetupIntentErrorMessage$ | async as errorMessage"
    type="danger"
    [message]="errorMessage"
    data-qa="test-company-payment-error-message"
  />

  @if ((companySettingsFacade.customerLoading$ | async) || (companySettingsFacade.paymentMethodsCardsLoading$ | async)) {
    <rx-skeleton-grid
      [numberOfItems]="2"
      [numberOfColumns]="1"
      itemHeight="49px"
      testId="test-company-payment-loading"
      style="width: 375px"
    />
  }

  <rx-applications-saved-payment-methods
    [theme]="'company-payment'"
    data-qa="test-company-payment-methods"
    [paymentMethods]="companySettingsFacade.paymentMethodsCardsUI$ | async"
    (deletePaymentMethod)="onDeletePaymentMethod($event)"
    (setDefaultPaymentMethod)="onSetDefaultPaymentMethod($event)"
  />

  <rx-button
    [disabled]="(companySettingsFacade.hasCustomer$ | async) === false"
    buttonClass="secondary"
    icon="rx-add"
    data-qa="test-company-payment-add-payment-button"
    (click)="openAddPaymentMethodModal()"
  >
    {{ t('addPayment') }}
  </rx-button>
</section>
